/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */

import React, { useState } from 'react';
import LabeledInputWithBlur from '../../../../sharedmodules/components/form-fields/labeled-input-with-blur';
import MultipleUsersDealers from './multiple-users-dealers';
import PropTypes from 'prop-types';

const DealerInputField = ({ handleExecute, handleReset }) => {

    const [userDetails, setUserDetails] = useState({ pin: '', dealerIds: '', status: '' });
    const [isMultipleVisible, setIsMultipleVisible] = useState(false);
    const isVsrError = '';

    const [fieldTouch, setFieldTouched] = useState({
        pin: false, dealerIds: false, status: false,
    });
    const [label, setLabel] = useState('');

    const handleInputChange = (e) => {

        e.preventDefault();
        setUserDetails({
            ...userDetails,
            [e.target.name]: e.target.value,
        });
        setFieldTouched({
            ...fieldTouch,
            [e.target.name]: true,
        });

    };

    const isValidDetails = false;

    const validateExecuteButton = () => userDetails.pin === '' && userDetails.dealerIds === '' && userDetails.status === '';

    const addMultipleData = (labelValue) => {

        setIsMultipleVisible(true);
        setLabel(labelValue);

    };

    const handleSubmit = (labelData, data) => {

        if (labelData === 'STATUS') {

            setUserDetails({
                ...userDetails,
                status: data,
            });

        }
        if (labelData === 'PIN') {

            setUserDetails({
                ...userDetails,
                pin: data,
            });

        }
        if (labelData === 'DEALER_ACCOUNT') {

            setUserDetails({
                ...userDetails,
                dealerIds: data,
            });

        }
        if (data !== '') {

            setIsMultipleVisible(false);

        }

    };

    return (
        <div className="dealer-settings-body">
            <div className="input-details">
                <div className="input-fields">
                    <LabeledInputWithBlur
                        className="user-id"
                        name="pin"
                        errorMessage="PIN_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="PIN"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={userDetails.pin}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                    <LabeledInputWithBlur
                        className="user-id"
                        name="dealerIds"
                        errorMessage="DEALER_ACCOUNT_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="DEALER_ACCOUNT"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={userDetails.dealerIds}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                    <LabeledInputWithBlur
                        className="user-id"
                        name="status"
                        errorMessage="STATUS_IS_REQUIRED"
                        highlightClass={isValidDetails ? '' : ''}
                        isEditable
                        isValid
                        label="STATUS"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={userDetails.status}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                </div>
                {isMultipleVisible && (
                    <MultipleUsersDealers
                        handleSubmit={handleSubmit}
                        label={label}
                        onClose={() => setIsMultipleVisible(false)}
                        userDetails={userDetails}
                    />
                )}
            </div>
            <div className="button-layout">
                <button
                    type="button"
                    onClick={() => {

                        setUserDetails({ pin: '', dealerIds: '', status: '' }); handleReset();

                    }}
                >

Reset
                </button>
                <button type="button" id="execute" onClick={() => handleExecute(userDetails)} disabled={validateExecuteButton()}>

Execute
                </button>
            </div>
        </div>

    );

};

DealerInputField.propTypes = {
    handleExecute: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
};

export default DealerInputField;
